// extracted by css-extract-rspack-plugin
export default {"bui-Link":"wSnVOKuBJ41yI4us"};